import moment from "moment";

export const COUPON_VALIDITY_DAYS = 13;

export const getCouponExpiry = (issued) => {
  if (!issued) return null;
  const parsed = moment(issued);
  if (!parsed.isValid()) return null;
  return parsed.add(COUPON_VALIDITY_DAYS, "days");
};

export const formatCouponExpiry = (issued, format = "DD MMM YY") => {
  const expiry = getCouponExpiry(issued);
  return expiry ? expiry.format(format) : "";
};

export const getFieldsValue = (data, name) => {
  const value = data?.find((item) => item.name == name);
  return value?.value;
};

export const formatIndianNumber = (num, decimals = 2) => {
  const number = parseFloat(num || 0).toFixed(decimals);
  const [integerPart, decimalPart] = number.split('.');
  
  // Indian numbering system: last 3 digits, then groups of 2
  const lastThree = integerPart.slice(-3);
  const otherNumbers = integerPart.slice(0, -3);
  
  const formattedInteger = otherNumbers !== '' 
    ? otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + ',' + lastThree
    : lastThree;
  
  return decimalPart ? `${formattedInteger}.${decimalPart}` : formattedInteger;
};

export const formatRewardCatalogueAmount = (num) => {
  const number = parseFloat(num || 0);
  return Number.isNaN(number) ? "0" : formatIndianNumber(Math.trunc(number), 0);
};
